import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../UnidadeMedida/UnidadeMedida.css'; // Importa os estilos do módulo

function UnidadeMedidaForm({ initialData = {}, onSubmit, loading, isEditing = false }) {
    const [descricao, setDescricao] = useState('');
    const [sigla, setSigla] = useState('');

    useEffect(() => {
        if (initialData && Object.keys(initialData).length > 0) {
            setDescricao(initialData.descricao || '');
            setSigla(initialData.sigla || '');
        }
    }, [initialData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({ descricao, sigla });
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-card">
                <h5 className="form-section-header">Informações da Unidade</h5>

                <div className="row g-3">
                    {/* Campo Descrição */}
                    <div className="col-md-8">
                        <label htmlFor="descricao" className="form-label-custom">Descrição *</label>
                        <input
                            type="text"
                            className="form-control form-control-custom"
                            id="descricao"
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>

                    {/* Campo Sigla */}
                    <div className="col-md-4">
                        <label htmlFor="sigla" className="form-label-custom">Sigla *</label>
                        <input
                            type="text"
                            className="form-control form-control-custom"
                            id="sigla"
                            value={sigla}
                            onChange={(e) => setSigla(e.target.value)}
                            required
                        />
                    </div>
                </div>
            </div>

            {/* FIXED FOOTER Actions */}
            <div className="form-actions-bar">
                <Link to="/app/unidadesmedida" className="btn btn-secondary-custom">
                    Cancelar
                </Link>
                <button type="submit" className="btn btn-primary-custom" disabled={loading}>
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Salvando...
                        </>
                    ) : (
                        <>
                            <i className="fas fa-save"></i>
                            {isEditing ? 'Atualizar Unidade' : 'Salvar Unidade'}
                        </>
                    )}
                </button>
            </div>
        </form>
    );
}

export default UnidadeMedidaForm;
